import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import '../../styles/assets/js/bootstrap.min.css'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import ReactPixel from 'react-facebook-pixel'
import axios from 'axios'
import { connectNode } from '../../utils/global'
import { loadLocationWithMessage } from '../../actions/location'
import '../../styles/assets/css/compare/dauten.css'
import '../../styles/assets/css/compare/compare_new_1.css'
import { Helmet } from "react-helmet"
import ReactPlayer from 'react-player'
import NavigationIcon from '@material-ui/icons/Navigation'

class ResearchCompareNew1 extends Component {
  constructor() {
      super()
      this.state = {
        language: 'en'
      }
  }

  componentDidMount() {
    ReactPixel.init('1230911777821192');
    ReactPixel.pageView()
  }

  handleEnrollClick = async (e) => {
    window.open("https://redcap.partners.org/redcap/surveys/?s=CJM9F7FJACKYH399")
    ReactPixel.track('enroll_button_1')
    const res = await axios.get('https://geolocation-db.com/json/')
    axios({
      method: 'post',
      url: connectNode + 'public/general/count_enroll_click',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { ip: res.data.IPv4 }
    })
    .then((result) => { })
  }

  handleEnrollClick2 = async (e) => {
    window.open("https://redcap.partners.org/redcap/surveys/?s=CJM9F7FJACKYH399&dcbi=2")
    ReactPixel.track('enroll_button_2')
    const res = await axios.get('https://geolocation-db.com/json/')
    console.log(res.data.IPv4)
    axios({
      method: 'post',
      url: connectNode + 'public/general/count_enroll_click',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { ip: res.data.IPv4 }
    })
    .then((result) => { })
  }

  changeLanguage = (language) => {
    this.setState({ language: language })
  }

  render() {
    return (
      <div class="research COMPARE">
      <div class="container-fluid sectHeader">
        <div class="row d-flex align-items-center no-margin">
          <div class="col-md-3 offset-md-1 col-sm-4 offset-sm-1 col-xs-6 offset-xs-3">
          <img src="/img/CompareLogo_Tag_EOMH.png" width="600" height="163" alt="COMPARE: Expanding Options for Healthcare"/>
          </div>
          <div class="col-md-6 offset-md-1 col-sm-5 offset-sm-1 col-xs-8 offset-xs-2 text-sm-end text-center header_hospitals">
            {/*<div className="language_bar">
              <div className={"lang_es "+((this.state.language=='es' && 'active')||(this.state.language=='en' && 'inactive'))}>
                <a onClick={(e)=>this.changeLanguage('es')}>ES</a>
              </div>
              <div className={"lang_en "+((this.state.language=='en' && 'active')||(this.state.language=='es' && 'inactive'))}>
                <a onClick={(e)=>this.changeLanguage('en')}>EN</a>
              </div>
              {this.state.language == 'en' &&
              <div className="arrow_bar1">
              <span className="">Para español</span>
              <NavigationIcon className="arrow1"/>
              </div>}
              {this.state.language == 'es' &&
              <div className="arrow_bar2">
              <div className="row">
                <div className="small-11 columns no-padding align_right">
                  For English, click here
                </div>
                <div className="small-1 columns no-padding">
                  <NavigationIcon className="arrow2"/>
                </div>
              </div>
              </div>}
            </div>*/}
            <p>Atrium Wake Forest Baptist</p>
            <p>Butler Hospital</p>
            <p>Hennepin Healthcare</p>
            <p>Massachusetts General Hospital</p>
          </div>
        </div>
      </div>
      <div class="container-fluid frontIntro">
        <div class="row d-flex align-items-center g-md-5">
          <div class="col-md-7 offset-md-1 colText top_space2 ">
            <p><h1 className="black_txt">Recruitment for this study has ended.</h1></p>
            <p className="black_txt txt_w5">THANK YOU!</p>
            <p className="black_txt txt_w5">Without your help, this study would not be possible.</p>
          </div>
          <div class="col-md-3 offset-md-0 colText blocked">
            <p>
              <span className="bold1">520</span><br />
              Total participants</p>
            <p><span className="bold1">3 Years</span><br />
            Study has been active</p>
            <p><span className="bold1">4 States</span><br />
            <ul>
              <li>Massachusetts</li>
              <li>Minnesota</li>
              <li>Rhode Island</li>
              <li>North Carolina</li>
            </ul>
            </p>
          </div>
        </div>
      </div>

      <div class="container-fluid sectionJoinUs">
      <div class="row d-flex">
        <div class="col-lg-10 offset-lg-1 order-lg-1 col-md-10 offset-md-1 order-md-2 order-sm-2 order-xs-2 colText">
          <p><ul>
            <li>We recruited 520 adults with depression to learn how yoga and talk therapy compare as treatments for depression.</li>
            <li>Our participants had 12 weeks of either:
            <ul>
              <li>
                a gentle, easy-to-do form of yoga focused on breathing, stretching, and relaxation
              </li>
              <li>
                a talk therapy called behavioral activation that helps motivate people to get out and do things that are important to them
              </li>
            </ul>
            </li>
            <li>If we find out that both these treatments work, we will have more ways  to help people with depression.</li>
          </ul></p>
          <div className="txt_w6 col-lg-10 top_space3">The study has now entered the data analysis phase.</div>
          <div className="txt_w6 col-lg-10 top_space3">Check back here to find out what we’ve learned!</div>
        </div>
      </div>
      </div>

      <div class="container-fluid sectionStudy">
        <div class="row align-items-center">
          <div class="col-md-6 offset-md-6 colText">
            <h2>To learn more about behavioral activation: </h2>
            <p><a href="https://www.psychologytoday.com/us/therapy-types/behavioral-activation" target="_blank">https://www.psychologytoday.com/us/therapy-types/behavioral-activation</a></p>
            <h2 className="top_space3">To learn more about yoga and yoga therapy: </h2>
            <p><a href="https://yogatherapy.health/" target="_blank">https://yogatherapy.health/</a></p>
          </div>
        </div>
      </div>
      <div class="container-fluid sectionCalltoAction">
        <div class="row align-items-center">&nbsp;</div>
      </div>
      <div class="container-fluid sectPeopleStrip">
        <div class="row">
          <div class="col"> <img src="/img/people-strip.jpg" width="2015" height="245" alt=""/> </div>
        </div>
      </div>
      <div class="container-fluid sectionFooter">
        <div class="row align-items-center">
          <div class="col-md-10 offset-md-1">
            <p>&nbsp;<br />
              Copyright © 2007-2022. The General Hospital Corporation. All Rights Reserved. | Image by <a href="https://www.freepik.com/free-photo/medium-shot-women-talking-therapy_13360967.htm" target="_blank">Freepik</a></p>
          </div>
        </div>
      </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ResearchCompareNew1)
